import { render, staticRenderFns } from "./KioskFooter.vue?vue&type=template&id=c193e0fe&"
import script from "./KioskFooter.vue?vue&type=script&lang=js&"
export * from "./KioskFooter.vue?vue&type=script&lang=js&"
import style0 from "./KioskFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskFooter.vue"
export default component.exports